/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { automaticDownload, displayErrorMsg, displayInfoMsg, displaySuccessMsg, formatDateToDatabase, odataLogs, seleccionarIdiomaYFormatoRegional, csvmaker, devuelveBasePath } from '@src/utility/utils'
import { settings, Email, MailControllerApi, ObservacionesControllerApi, PortesControllerApi, NavisionControllerApi, ClientesControllerApi, MultiempresasControllerApi } from '@api/backend'
import Swal from 'sweetalert2'
import { getUserCode, isParentUser } from '@src/auth/utils'
import { FormattedMessage, useIntl } from 'react-intl'
import axios from 'axios'
import { Check, X } from 'react-feather'
import { getUserData } from '@utils'
import instance from '@api/pim'
import { store } from '@store/storeConfig/store'
import { useSelector } from 'react-redux'
import { actualizarFiltrosPantalla, obtenerFiltrosPantalla } from '@src/views/productos/store/actions'

const prefix = 'sales-quote'
const config = settings
export const GET_SALES_QUOTE = `${prefix}/GET_SALES_QUOTE`
export const GET_SALES_QUOTES = `${prefix}/GET_DATA`
export const GET_SALES_QUOTE_PDF = `${prefix}/GET_SALES_QUOTE_PDF`
export const INIT_REQUEST = `${prefix}/INIT_REQUEST`
export const INIT_SALES_QUOTE_PDF = `${prefix}/INIT_SALES_QUOTE_PDF`
export const INIT_DOWNLOAD_SALES_QUOTE_PDF = `${prefix}/INIT_DOWNLOAD_SALES_QUOTE_PDF`
export const DOWNLOAD_SALES_QUOTE_PDF = `${prefix}/DOWNLOAD_SALES_QUOTE_PDF`
export const SEND_SALES_QUOTE = `${prefix}/SEND_SALES_QUOTE`
export const SET_SALES_QUOTE_FROM_ALLDATA = `${prefix}/SET_SALES_QUOTE_FROM_ALLDATA`
export const SWITCH_BILLTO_SELLTO = `${prefix}/SWITCH_BILLTO_SELLTO`


// API Backend instance
const apiMail = new MailControllerApi(settings)
const apiObs = new ObservacionesControllerApi(settings)
const apiPortes = new PortesControllerApi(settings)
const apiNavisionNew = new NavisionControllerApi(settings)
const clienteasApi = new ClientesControllerApi(settings)
const multiempresasApi = new MultiempresasControllerApi(settings)

// ** INIT REQUEST
export const initRequest = () => {
  return async (dispatch) => {
    dispatch({
      type: INIT_REQUEST
    })
  }
}

export const enviarObservacion = (observacion, documentNo, cliente) => {
  return async (dispatch) => {
    const objObservacion = { oferta: documentNo, contenido: observacion, cliente }
    const whereFilters = {}
    whereFilters['oferta'] = { like: `%${documentNo}%` }
    const filter = {
      where: { ...whereFilters }
    }
    const { data: dataObservacion } = await apiObs.observacionesControllerFind(JSON.stringify(filter))
    if (dataObservacion != undefined && dataObservacion.length > 0) {
      await apiObs.observacionesControllerUpdateById(dataObservacion[0].id, objObservacion)
    } else {
      await apiObs.observacionesControllerCreate(objObservacion)
    }
  }
}

/*  Código obsoleto. Se ha creado la función csvmaker en /utility/utils.js para englobar las funciones csvmaker que hay, en una sola
const csvmaker = function (data) {
  const valorMinimoParaNoIncluirPortes = 750 // Por encima de este valor, no se añaden los portes al pedido
  let sumaTotal = 0
  const csvRows = []
  const headers = Object.keys(data[0])

  // Verificar si el header 'postes' existe en los datos que llegan, cambiarlo por 'portes'
  if (headers.includes('postes')) {   
    const indiceAReemplazar = headers.indexOf('postes');
    headers[indiceAReemplazar] = 'portes'; // Reemplazamos 'postes' por 'portes'
  }    

  const indiceAEliminar = headers.indexOf('salesQuoteLines');
  if (indiceAEliminar !== -1) {
    headers.splice(indiceAEliminar, 1); // Eliminamos la cabecera (salesQuoteLines)
  }
  headers.push('total') // Agregamos la cabecera (total)
  headers.push('total con portes') // Agregamos la cabecera (total con portes)

  let values
  csvRows.push(headers.splice(1, headers.length - 1).join(';'))
  Object.values(data).forEach(value => {

    // Suma todas las líneas que llegan, incluídos los portes, que llegan en una línea con propiedad->no y valor->'PORTES'
    const sumaTotalArticulosYPortes = (value.salesQuoteLines && value.salesQuoteLines.length > 0) ? value.salesQuoteLines.reduce((valorAcumulado, valorActual) => valorAcumulado + (valorActual.quantity * valorActual.unitPrice), 0) : 0; // Se añade este código para calcular el total, si no, al descargar el csv, pone [object]

    const valorPortes = (value.salesQuoteLines.find(linea => linea.no === 'PORTES') ?? { lineAmount: 0 }).lineAmount; // Obtiene el valor de la línea 'PORTES', es decir, si la propiedad 'no' tienen como valor 'PORTES', si no, devuelve 0
    const sumaTotalArticulosSinPortes = parseFloat(sumaTotalArticulosYPortes) - parseFloat(valorPortes) // Calcula el valor de todos los artículos sin los portes

    // Hay un valor mínimo para el que si los artículos comprados superan esa cifra, entonces no se incluyen los portes
    if (sumaTotalArticulosSinPortes > valorMinimoParaNoIncluirPortes) {
      sumaTotal = parseFloat(sumaTotalArticulosYPortes) - parseFloat(valorPortes) // Calcula la suma total sin los portes
    } else {
      sumaTotal = parseFloat(sumaTotalArticulosYPortes)   // Por no superar el valorMinimoParaNoIncluirPortes, se incluyen lor portes
    }

    delete value.salesQuoteLines; // Eliminamos la columna (salesQuoteLines)
    values = Object.values(value)
    values.push(sumaTotalArticulosSinPortes.toFixed(2).replace('.', ',')) // Agregamos la columna (total). Reemplaza los puntos que hay, por comas, para seguir la notación numérica española
    values.push(sumaTotal.toFixed(2).replace('.', ',')) // Agregamos la columna (total con portes)
    csvRows.push(values.splice(1, values.length - 1).join(';'))
  })
  return csvRows.join('\n')
}
*/
const descargaFichero = function (data) {
  const blob = new Blob([data], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', '/ofertas.csv')
  a.click()
}

export const descargarCsv = (params, intl) => {
  return async (dispatch) => {
    dispatch(initRequest())
    const {
      page = 1,
      perPage = 10,
      documentNo = null,
      postingDate = null,
      shipmentDate = null,
      shipToCity = null,
      shipToAddress = null,
      sellToCustomerName = null,
      customerNo = null,
      vendedor = null,
      gerente = null
    } = params

    const filterList = []
    if (documentNo) {
      filterList.push(`documentNo eq '*${documentNo}*'`)
    }
    if (postingDate && postingDate.length) {
      if (postingDate.length === 2) {
        filterList.push(`postingDate ge ${formatDateToDatabase(postingDate[0])}`)
        filterList.push(`postingDate le ${formatDateToDatabase(postingDate[1])}`)
      } else {
        filterList.push(`postingDate eq ${formatDateToDatabase(postingDate[0])}`)
      }
    }
    if (shipmentDate && shipmentDate.length) {
      if (shipmentDate.length === 2) {
        filterList.push(`shipmentDate ge ${formatDateToDatabase(shipmentDate[0])}`)
        filterList.push(`shipmentDate le ${formatDateToDatabase(shipmentDate[1])}`)
      } else {
        filterList.push(`shipmentDate eq ${formatDateToDatabase(shipmentDate[0])}`)
      }
    }
    if (shipToCity) {
      filterList.push(`shiptoCity eq '*${shipToCity}*'`)
    }
    if (shipToAddress) {
      filterList.push(`shipToAddress eq '*${shipToAddress}*'`)
    }
    if (sellToCustomerName) {
      filterList.push(`sellToCustomerName eq '*${sellToCustomerName}*'`)
    }
    if (gerente === "off" || gerente === "" || gerente === null || gerente === undefined) {
      if (vendedor) {
        filterList.push(`salespersonCode eq '${vendedor}'`) //->Filtramos por el codigo exacto del vendedor, sin añadir *__*
      }
    }
    if (customerNo) {
      filterList.push(`sellToCustomerNo eq '*${customerNo}*'`)
    }

    const $filter = filterList.join(' and ')
    const $top = perPage
    const $skip = (page - 1) * perPage
    const $orderby = 'documentNo desc'
    const $expand = 'salesQuoteLines'
    const $count = true
    Swal.fire({
      title: intl.formatMessage({ id: 'Generating csv' }),
      html: intl.formatMessage({ id:  'Please wait'}),
      timer: $top * 1.5,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      }
    })
      await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', $filter, $top, $skip, $orderby, $expand, $count).then((response) => {
        const { data } = response;
        if (response.data?.mensaje?.message) {
          return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }
        //
        //Calculamos la suma de los volumenes de cada línea y actualizamos el registro cabecera que es el que mostramos 
        //
        let nuevoVolumenCalculado = 0;
        (data.value).forEach(lines => {        
          if (lines.salesQuoteLines.length > 0) {
            let volumenTotal = 0, decimal = "0"
            lines.salesQuoteLines?.forEach(el => {
              volumenTotal += el.totalVolume
            })
            const volString = volumenTotal.toString().split(".")
            const entero = volString[0]
            if (volString.length > 1) {
              decimal = volString[1].substring(0, 2)
            }
            if (decimal.length === 1) {
              decimal = decimal.concat("0"); // Completar con un 0 si la parte decimal es de un solo dígito
            }
            nuevoVolumenCalculado = entero.concat(",").concat(decimal)
          } 
          lines.volumen = nuevoVolumenCalculado
        })
        //
        //Generamos el fichero
        //
        const csvdata = csvmaker(data.value)
        descargaFichero(csvdata)
        location.reload()
      })
  }
}

export const descargarCsvCartera = (params, intl) => {
  return async (dispatch) => {
    dispatch(initRequest())
    const {
      page = 1,
      perPage = 10,
      customerNo = null,
      vendedor = null,
      gerente = null
    } = params

    const filterList = []
    if (gerente === "off" || gerente === "" || gerente === null || gerente === undefined) {
      if (vendedor) {
        filterList.push(`salespersonCode eq '${vendedor}'`) //->Filtramos por el codigo exacto del vendedor, sin añadir *__*
      }
    }
    if (customerNo) {
      filterList.push(`sellToCustomerNo eq '*${customerNo}*'`)
    }

    const $filter = filterList.join(' and ')
    const $top = perPage
    const $skip = (page - 1) * perPage
    const $orderby = 'documentNo desc'
    Swal.fire({
      title: intl.formatMessage({ id: 'Generating csv' }),
      html: intl.formatMessage({ id:  'Please wait'}),
      timer: $top * 1.5,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      }
    })
    await apiNavisionNew.navisionControllerGetendPoint('salesQuoteLines', $filter, $top, $skip, $orderby, undefined, undefined).then((response) => {

      if (response.data?.mensaje?.message) {
        return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
      }

      const { data } = response
      const csvdata = csvmaker(data.value)
      descargaFichero(csvdata)
      location.reload()
    })
  }
}

// Función para armar el filtro de ofertas y guardarlo en la base de datos
export const armarFiltroOfertas = async (
  numeroDocumento,
  fechaPublicacion,
  codigoCliente,
  ciudad,
  direccionEnvio,
  yourReference,
  modeloProducto,
  categoriaProducto
) => {
  try {
    const { id } = getUserData();

    // Obtener filtros actuales
    let filtrosActuales = await obtenerFiltrosPantalla(id, 'ofertas');

    if (!filtrosActuales) {
      filtrosActuales = {
        documentNo: '',
        postingDate: '',
        customerNo: '',
        shipToCity: '',
        shipToAddress: '',
        yourReference: '',
        modelo: '',
        categoria: ''
      };
    }

    // Crear un nuevo objeto combinando los valores existentes y los que SÍ se pasan (incluso si son vacíos)
    const nuevosFiltros = {
      ...filtrosActuales,
      ...(numeroDocumento !== undefined && { documentNo: numeroDocumento }),
      ...(fechaPublicacion !== undefined && { postingDate: fechaPublicacion }),
      ...(codigoCliente !== undefined && { customerNo: codigoCliente }),
      ...(ciudad !== undefined && { shipToCity: ciudad }),
      ...(direccionEnvio !== undefined && { shipToAddress: direccionEnvio }),
      ...(yourReference !== undefined && { yourReference }),
      ...(modeloProducto !== undefined && { modelo: modeloProducto }),
      ...(categoriaProducto !== undefined && { categoria: categoriaProducto })
    };

    const jsonString = JSON.stringify(nuevosFiltros);
    const respuesta = await actualizarFiltrosPantalla(id, 'ofertas', jsonString);
    console.log('Respuesta de la API:', respuesta);
  } catch (error) {
    console.error('Error al guardar los filtros de la pantalla ofertas:', error);
  }
};

// ** Get Delivery Notes list
export const getData = (intl, params) => {
  return async (dispatch, getState) => {
    dispatch(initRequest())
    const {
      page = 1,
      perPage = 10,
      status = null,
      documentNo = null,
      yourReference = null,
      postingDate = null,
      shipmentDate = null,
      shipToCity = null,
      shipToAddress = null,
      ean = null,
      description = null,
      productCode = null,
      sellToCustomerName = null,
      customerNo = null,
      vendedor = null,
      gerente = null
    } = params

    try {
      let $filter
      let total
      let $top = perPage
      let $skip = (page - 1) * perPage
      const inicio = ((page - 1) * perPage)
      const fin = inicio + perPage
      const $orderby = 'documentNo desc'
      const $expand = 'salesQuoteLines'
      const $count = true
      const filterList = []
      const customerNoFilter = getUserCode()
      const isParent = await isParentUser()

      // Filtros para Lineas
      if (ean || description || productCode || vendedor || customerNo) {
        const filterLines = [...filterList]

        if (ean) {
          filterLines.push(`no eq '${ean}'`)
        }
        if (description) {
          filterLines.push(`description eq '*${description}*'`)
        }
        if (productCode) {
          filterLines.push(`barCode eq '*${productCode}*'`)
        }
        //if (gerente === "off" || gerente === "" || gerente === null || gerente === undefined) {
          if (vendedor) {
            filterList.push(`salespersonCode eq '${vendedor}'`) //->Filtramos por el codigo exacto del vendedor, sin añadir *__*
          }
        //}
        //if (gerente === "off" || gerente === "" || gerente === null || gerente === undefined) {
          if (customerNo) {
            filterList.push(`sellToCustomerNo eq '*${customerNo}*'`)
          }
        //}

        // Join array de Filtros y reemplazo de campos 'shiptoCity' a 'shipToCity' por diferencia entre cabecera y lineas
        const $filterLines = filterLines.join(' and ')
          .replace('documentNo', 'no') //? CREO QUE NO VA
          .replace('shiptoCity', 'shipToCity')

        // Consulta API de query (líneas y cabecera): Máximo 100000 registros
        let ids = []
        if ($filterLines != '') {
          const linesData = await apiNavisionNew.navisionControllerGetendPoint('salesQuoteLines', $filterLines, 100000, 0, undefined, undefined, undefined)
          ids = [...new Set(linesData.data.value?.map(line => line.no))]
        }
        // Obtener array único de Documentos
        if (ids.length > 0) {
          // Variables de Paginacion cuando busca lineas
          const start = ((page - 1) * perPage)
          const end = start + perPage

          // Calcula total de registros para paginación
          total = ids.length

          // Obtener la parte del array de DocumentNo para la pagina solicitada
          const idsPaginated = total > perPage ? ids.slice(start, end) : ids

          // Agrega filtros por los documentos de la pagina
          const list = idsPaginated.map(ids => `documentNo eq '${ids}'`).join(' or ')

          if (list) {
            // Agrega filtros por los documentos de la pagina y modifica parametros de paginación
            filterList.push(`(${list})`)
            $top = perPage
            $skip = 0
          }
        }
        // Filtros para Cabecera
        if (status || documentNo || yourReference || postingDate || shipmentDate || shipToCity || shipToAddress || customerNoFilter || sellToCustomerName || gerente) {
          if (customerNo) {
            if (isParent) {
              const showFromHijos = getState().salesQuote.showFromHijos
              if (showFromHijos) {
                filterList.push(`billtoCustomerNo eq '*${customerNoFilter}*'`)
                // filterList.push(`sellToCustomerNo <> '*${customerNo}*'`)
              } // else filterList.push(`sellToCustomerNo eq '*${customerNoFilter}*'`)
            } // else filterList.push(`sellToCustomerNo eq '*${customerNoFilter}*'`)
          }
          if (documentNo) {
            filterList.push(`documentNo eq '*${documentNo}*'`)
          }
          if (postingDate && postingDate.length) {
            if (postingDate.length === 2) {
              filterList.push(`orderDate ge ${formatDateToDatabase(postingDate[0])}`)
              filterList.push(`orderDate le ${formatDateToDatabase(postingDate[1])}`)
            } else {
              filterList.push(`orderDate eq ${formatDateToDatabase(postingDate[0])}`)
            }
          }
          if (shipmentDate && shipmentDate.length) {
            if (shipmentDate.length === 2) {
              filterList.push(`shipmentDate ge ${formatDateToDatabase(shipmentDate[0])}`)
              filterList.push(`shipmentDate le ${formatDateToDatabase(shipmentDate[1])}`)
            } else {
              filterList.push(`shipmentDate eq ${formatDateToDatabase(shipmentDate[0])}`)
            }
          }
          if (shipToCity) {
            filterList.push(`shiptoCity eq '*${shipToCity}*'`)
          }
          if (shipToAddress) {
            filterList.push(`shipToAddress eq '*${shipToAddress}*'`)
          }
          if (sellToCustomerName) {
            filterList.push(`billtoName eq '*${sellToCustomerName}*'`)
          }
          if (yourReference) {
            filterList.push(`yourReference eq '*${yourReference}*'`)
          }

          if (filterList.length) {
            $filter = filterList.join(' and ')
          }
        }
        $filter = filterList.join(' and ')
      }
      await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', $filter, undefined, undefined, $orderby, $expand, $count).then((response) => {

        if (response.data?.mensaje?.message) {
          return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }

        const { data } = response

        const registrosPaginados = data.value.slice(inicio, fin); // -> Filtra pagina
        console.log('Ofertas: ', registrosPaginados)
        armarFiltroOfertas(documentNo, postingDate, customerNo, shipToCity, shipToAddress, yourReference, undefined, undefined) // -> Guarda filtros de la pantalla ofertas en la base de datos
        dispatch({
          type: GET_SALES_QUOTES,
          allData: data.value,
          data: registrosPaginados,
          totalPages: total || data['@odata.count'] || 0,
          params
        })
        odataLogs(response.config.url, response.status, response.config.method, GET_SALES_QUOTES, config)
      }).catch((err) => odataLogs(err.message, "ERROR", "", GET_SALES_QUOTES, config))
    } catch (err) {
      console.error(err.message)
      Swal.fire({
        title: intl.formatMessage({ id: "Error in Navision"}),
        icon: "error"
      })
    }
  }
}

const getCodigoMarca = (marca) => {
  const codMarcas = [
  {cod: 'SV', nombre: 'SVAN'}, 
  {cod: 'NL', nombre: 'NILSON'}, 
  {cod: 'AS', nombre: 'ASPES'}, 
  {cod: 'WD', nombre: 'WONDER'}, 
  {cod: 'TO', nombre: 'TOSHIBA'}, 
  {cod: 'SH', nombre: 'SHARP'},
  {cod: 'HY', nombre: 'HYUNDAI'},
  {cod: 'SS', nombre: 'SVAN SOLAR'}
  ]
  const codigo = codMarcas.find(el => el.nombre.toLowerCase() == marca.toLowerCase())
  return codigo?.cod
}

async function fetchCompaniesForProducts(products, clientes) {
  try {
      // Iterar sobre el array de productos
      if (!Array.isArray(products)) {
        products = [products];
      }
      const promises = products.map(async (product) => {
          const categoria = product.itemCategoryParent || product.category; // Asegurarse de obtener la categoría correcta
          // Llamar a multiempresasControllerSearchCompanies para cada producto
          const response = await multiempresasApi.multiempresasControllerSearchCompanies(
              getCodigoMarca(product.brand),
              categoria || '',
              product.categoria_padre || '',
              clientes
          );
          // Manejar la respuesta
          const companyData = response.data[0]; // Asumiendo que la respuesta es un array con un objeto
          return { product, companyData };
      });

      // Esperar a que todas las promesas se resuelvan
      const allCompaniesData = await Promise.all(promises);

      // Agrupar los productos por compañía
      const groupedByCompany = allCompaniesData.reduce((acc, { product, companyData }) => {
          const companyName = companyData.company; // Acceder correctamente al nombre de la compañía
          if (!acc[companyName]) {
              acc[companyName] = [];
          }
          acc[companyName].push(product);
          return acc;
      }, {});

      return groupedByCompany;
  } catch (error) {
      // Manejar los errores
      console.error('Error fetching companies for products:', error);
      throw error;
  }
}

export const cancelQuote = (documentNo, productsArr, intl, company, storeProducto) => {
  return async () => {
    try {
      if (company !== 43) {
        const objNew = { documentNo };
        const objJSON = JSON.stringify(objNew); // <-- creamos el JSON a enviar
        await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_CancelQuote", objJSON).then((response) => {
          if (response?.data?.mensaje?.message) {
            return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
          }
          const { data } = response
          if (data == 'OK') {
            displaySuccessMsg(`${intl.formatMessage({ id: 'Sales Quote'})} ${documentNo} ${intl.formatMessage({ id: 'canceled'})}`)
            return data
          }
          //
          //Si ha ocurrido algún problema mostramos el error
          //
          if (data.mensaje.message) { 
            return displayErrorMsg(data.mensaje.message)
          }
        })
      } else {
        const splitDocumentNo = documentNo.split('-');
        const promises = productsArr.map(async product => await instance().get(`/B2bProductos/${product.no}`));
        // Esperar a que todas las promesas se resuelvan
        const results = await Promise.all(promises);
        // Extraer los datos de los resultados
        const productosPim = results.map(result => result.data);
        const productosPimAplanado = productosPim.flat();
        let companies = [];
        await fetchCompaniesForProducts(productosPimAplanado, localStorage.getItem('clienteDefecto').split(' ')[0]).then(allCompaniesData => {
          companies = Object.keys(allCompaniesData);
        }).catch(error => {
          console.error('Error en la llamada a fetchCompaniesForProducts:', error);
        }); 
        const messages = [];
        for (const [index, part] of splitDocumentNo.entries()) {
          const objNew = { documentNo: part.trim(), pEmpresa: companies[index] };
          const objJSON = JSON.stringify(objNew); // <-- creamos el JSON a enviar
          const response = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_CancelQuote", objJSON);
          if (response?.data?.mensaje?.message) {
            return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
          }
          const { data } = response;
          let mensaje = '';
          if (data.status === 'OK') {
            mensaje = `${intl.formatMessage({ id: 'Sales Quote'})} ${part} ${intl.formatMessage({ id: 'canceled'})}`;
            messages.push(['OK', mensaje]);
          } else if (data.mensaje && data.mensaje.message) {
            messages.push(['KO', data.mensaje.message]);
          }
        }
        let textoRespuesta = '';
        messages.forEach(([status, message]) => {
          textoRespuesta += `${message}<br><br>`;
        });
        Swal.fire({
          icon: 'warning',
          position: 'center',
          showConfirmButton: true,
          title: textoRespuesta
        }).then(() => {
          console.log('Cerrado');
        });
      }
    } catch (err) {
      console.error(err.message)
    }
  }
}

// ** Get Delivery Note
export const getSalesQuote = (params) => {
  return async (dispatch) => {
    const {
      page = 1,
      perPage = 1,
      documentNo = null,
      ofertaFiltrada = null,
      storeAdmin
    } = params

    try {
      const $top = perPage
      const $skip = (page - 1) * perPage
      const $orderby = 'documentNo desc'
      const $expand = 'salesQuoteLines'
      //const $expand = undefined
      const $count = undefined
      // Hago el filtro mas específico para obtener la oferta concreta que quiero mostrar en la vista previa
      const $filter = ofertaFiltrada != null ? `salespersonCode eq '${ofertaFiltrada?.salespersonCode}' and sellToCustomerNo eq '*${ofertaFiltrada?.sellToCustomerNo}*' and documentNo eq '*${documentNo}*'` : `documentNo eq '*${documentNo}*'`
      await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', $filter, $top, $skip, $orderby, $expand, $count).then(async (response) => {
        if (response.data?.mensaje?.message) {
          return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }
        const whereFilters = {}
        whereFilters['oferta'] = { like: `%${documentNo}%` }
        const filter = { where: { ...whereFilters } }
        const { data: dataObservacion } = await apiObs.observacionesControllerFind(JSON.stringify(filter))
        const { data: dataPortes } = await apiPortes.portesControllerFind()
        if (storeAdmin.companyId !== 43) {
          const { data } = response
          dispatch({
            type: GET_SALES_QUOTE,
            salesQuote: data.value?.pop(),
            portes: dataPortes,
            observacion: dataObservacion[0]
          })
          odataLogs(response.config.url, response.status, response.config.method, GET_SALES_QUOTE, config)
        } else {
          if (response.data.value[0].orderWeb !== '') {
            const $filterOrderWeb = `orderWeb eq '*${response.data.value[0].orderWeb}*'`
            await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', $filterOrderWeb, $top, $skip, $orderby, $expand, $count).then(async (responseOrderWeb) => {
              // Suponiendo que response es un array que puede contener arrays anidados
              const responseAplanado = responseOrderWeb.data.value.flat();
              // Combinar todos los salesQuoteLines en un solo array
              const combinedSalesQuoteLines = responseAplanado.reduce((acc, item) => {
                return acc.concat(item.salesQuoteLines);
              }, []);
              // Filtrar y agrupar las líneas de tipo "portes"
              const portesLines = combinedSalesQuoteLines.filter(line => line.no === 'PORTES');
              const nonPortesLines = combinedSalesQuoteLines.filter(line => line.no !== 'PORTES');
              
              if (portesLines.length > 0) {
                const combinedPortesLine = portesLines.reduce((acc, line) => {
                  acc['@odata.etag'] = response.data.value[0]['@odata.etag'];
                  acc.barCode = line.barCode;
                  acc.description = line.description;
                  acc.distributorPrice += line.distributorPrice;
                  acc.documentNo = response.data.value[0].documentNo;
                  acc.documentType = response.data.value[0].documentType;
                  acc.itemCategoryCode = response.data.value[0].itemCategoryCode;
                  acc.lineAmount += line.lineAmount;
                  acc.lineDiscountAmount += line.lineDiscountAmount;
                  acc.lineDiscountPercent += line.lineDiscountPercent;
                  acc.lineNo = response.data.value[0].lineNo;
                  acc.lineType = response.data.value[0].lineType;
                  acc.no = 'PORTES';
                  acc.portes = line.portes;
                  acc.postingDate = response.data.value[0].postingDate;
                  acc.quantity += line.quantity;
                  acc.requestedDeliveryDate = response.data.value[0].requestedDeliveryDate;
                  acc.salespersonCode = response.data.value[0].salespersonCode;
                  acc.sellToCustomerName = response.data.value[0].sellToCustomerName;
                  acc.sellToCustomerNo = response.data.value[0].sellToCustomerNo;
                  acc.totalVolume += line.totalVolume;
                  acc.unitPrice += line.unitPrice;
                  acc.vatPercent = response.data.value[0].vatPercent;
                  return acc;
                }, { barCode: '', description: '', distributorPrice: 0, documentNo: '', documentType: '', itemCategoryCode: '', lineAmount: 0, lineDiscountAmount: 0, lineDiscountPercent: 0, lineNo: '', lineType: '', no: 'PORTES', portes: '', postingDate: '', quantity: 0, requestedDeliveryDate: '', salespersonCode: '', sellToCustomerName: '', sellToCustomerNo: '', totalVolume: 0, unitPrice: 0, vatPercent: 0 });
                
                // Añadir la línea combinada de "portes" a las líneas no "portes"
                nonPortesLines.push(combinedPortesLine);
              }
              if (response.data.value[0].documentNo !== responseOrderWeb.data.value[0].documentNo) {
                response.data.value[0].documentNo = Array.from(new Set([...response.data.value.map(item => item.documentNo), ...responseOrderWeb.data.value.map(item => item.documentNo)])).join(' - ');
              }
              response.data.value[0].salesQuoteLines = nonPortesLines;
            })
          }
          console.log('Oferta: ', response.data.value[0])
          dispatch({
            type: GET_SALES_QUOTE,
            salesQuote: response.data.value[0],
            portes: dataPortes,
            observacion: dataObservacion[0]
          })
          odataLogs(response.config.url, response.status, response.config.method, GET_SALES_QUOTE, config)
        }
      }).catch((err) => odataLogs(err.message, "ERROR", "", GET_SALES_QUOTE, config))
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const consultarSiExisteOferta = (params) => {
  return async () => {
    const {
      page = 1,
      perPage = 1,
      documentNo = null
    } = params

    try {
      const $top = perPage
      const $skip = (page - 1) * perPage
      const $orderby = 'documentNo desc'
      const $expand = 'salesQuoteLines'
      const $count = undefined
      const $filter = `documentNo eq '*${documentNo}*'`
      return await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', $filter, $top, $skip, $orderby, $expand, $count).then(async (response) => {
        return response
      }).catch((err) => odataLogs(err.message, "ERROR", "", GET_SALES_QUOTE, config))
    } catch (err) {
      console.error(err.message)
    }
  }
}

// ** INIT PDF Albaran
export const initDeliveryNotePdf = () => {
  return async (dispatch) => {
    dispatch({
      type: INIT_SALES_QUOTE_PDF
    })
  }
}

// ** Get Delivery Note PDF
export const getSalesQuotePdf = (documentNo) => {
  return async (dispatch) => {
    try {
      const objNew = { DocNo: documentNo, DocType: 'Oferta' };
      const objJSON = JSON.stringify(objNew); // <-- creamos el JSON a enviar
      await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_PrintDocument", objJSON).then((response) => {
        if (response?.data?.mensaje?.message) {
          return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }
        const { data } = response
        dispatch({
          type: GET_SALES_QUOTE_PDF,
          salesQuotePdf: data
        })
        odataLogs(response.config.url, response.status, response.config.method, GET_SALES_QUOTE_PDF, config)
      })
        .catch((err) => odataLogs(err.message, "ERROR", "", GET_SALES_QUOTE, config))
    } catch (err) {
      console.error(err.message)
    }
  }
}


export const initDownloadSalesQuotePdf = () => {
  return async (dispatch) => {
    dispatch({
      type: INIT_DOWNLOAD_SALES_QUOTE_PDF
    })
  }
}

// ** Descargar PDF Oferta
export const downloadSalesQuotePdf = (documentNo, processing, codigoCliente, intl) => {
  return async (dispatch, getState) => {
    try {
      const admin = getState().admin.users.selectedUser
      if (processing && processing === true) dispatch(initRequest())
      // const objNew = { DocNo: documentNo, DocType: 'OFERTAVENTA' };
      if (admin.companyId === 43) {
        const splitIdentifier = documentNo.split('-').map(part => part.trim());
        for (const documentNo of splitIdentifier) {
          await apiNavisionNew.navisionControllerGetEmpresaPorIdDato(documentNo, 'documentNo', 'salesQuoteHeader', codigoCliente).then(async (response) => {
            console.log(response);
            const objNew = { DocNo: documentNo, DocType: 'OFERTAVENTA', idioma: seleccionarIdiomaYFormatoRegional(), companyId: response.data.companyId }; // Llama a la función que devuelve el idioma seleccionado por el usuario en el desplegable de la web
            const objJSON = JSON.stringify(objNew); // <-- creamos el JSON a enviar
            await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_PrintDocument", objJSON).then((response) => {
              if (response?.data?.mensaje?.message) {
                return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
              }
              const { data } = response
              // Escapa con notificacion error si encuentra error en la respuesta de navision
              if (data.status !== 'OK') return displayErrorMsg(`${intl.formatMessage({ id: 'Error al generar PDF en Navision'})}:${data.mensaje.message}`)
    
              dispatch({
                type: DOWNLOAD_SALES_QUOTE_PDF,
                salesQuotePdf: data.mensaje,
                documentNo
              })
              automaticDownload(`${documentNo}.pdf`, `data:application/pdf;base64,${data.mensaje}`)
              odataLogs(response.config.url, response.status, response.config.method, DOWNLOAD_SALES_QUOTE_PDF, config)
              displaySuccessMsg(intl.formatMessage({ id: 'Downloaded PDF'}))
            }).catch((err) => odataLogs(err.message, "ERROR", "", DOWNLOAD_SALES_QUOTE_PDF, config))
          });
        }
      } else {
        const objNew = { DocNo: documentNo, DocType: 'OFERTAVENTA', idioma: seleccionarIdiomaYFormatoRegional() }; // Llama a la función que devuelve el idioma seleccionado por el usuario en el desplegable de la web

        const objJSON = JSON.stringify(objNew); // <-- creamos el JSON a enviar
        await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_PrintDocument", objJSON).then((response) => {
          if (response?.data?.mensaje?.message) {
            return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
          }
          const { data } = response
          // Escapa con notificacion error si encuentra error en la respuesta de navision
          if (data.status !== 'OK') return displayErrorMsg(`${intl.formatMessage({ id: 'Error al generar PDF en Navision'})}:${data.mensaje.message}`)

          dispatch({
            type: DOWNLOAD_SALES_QUOTE_PDF,
            salesQuotePdf: data.mensaje,
            documentNo
          })
          automaticDownload(`${documentNo}.pdf`, `data:application/pdf;base64,${data.mensaje}`)
          odataLogs(response.config.url, response.status, response.config.method, DOWNLOAD_SALES_QUOTE_PDF, config)
          displaySuccessMsg(intl.formatMessage({ id: 'Downloaded PDF'}))
        }).catch((err) => odataLogs(err.message, "ERROR", "", DOWNLOAD_SALES_QUOTE_PDF, config))
      }
    } catch (err) {
      console.error(err.message)
    }
  }
}

// ** Fetch pdf y lo envia por correo
export const sendSalesQuotePdfEmail = (mailObject, documentNo, intl) => {
  return async (dispatch) => {
    try {
      Swal.fire({
        position: 'center',
        title: intl.formatMessage({ id: 'Process started on the server, a warning will be displayed on the screen at the end of the process.'}),
        icon: 'info'
      })
      await dispatch(getSalesQuotePdf(documentNo))
      await apiMail.mailControllerSendMail(mailObject).then((response) => {
        dispatch({
          type: SEND_SALES_QUOTE
        })
        odataLogs(response.config.url, response.status, response.config.method, SEND_SALES_QUOTE, config)
      })
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: intl.formatMessage({ id: 'E-mail sent'})
      }).catch((err) => odataLogs(err.message, "ERROR", "", SEND_SALES_QUOTE, config))
    } catch (err) {
      console.error(err.message)
    }
  }
}

// ** Set albaran desde alldata
export const setSalesQuoteFromAllData = (documentNo) => {
  return async (dispatch) => {
    dispatch({
      type: SET_SALES_QUOTE_FROM_ALLDATA,
      data: documentNo
    })
  }
}

export const convierteOfertaAPedido = async (objNew, intl, documentNo) => { 
  //
  //Se convierte la oferta a pedido
  //
  return await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_QuoteToOrder", JSON.stringify(objNew)).then(async (response) => {
    const { data } = response
    let texto = ''
    //
    //Almacenamos el resultado
    //
    if (data.status == 'OK') {
      //
      //Comprobamos si existe la oferta para saber si todos los productos de esta han pasado a pedido o ha sido un cambio parcial
      //
      const estadoOfertaActual = await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', `documentNo eq '${documentNo}'&$count=true&$expand=salesQuoteLines`, 100000, 0, undefined, undefined, undefined)
      //
      //Si no existe la oferta actual, significa que todos los productos de la oferta han pasado a pedido
      //
      if (estadoOfertaActual.data['@odata.count'] === 0) {
        texto = { status: 'OK', mensaje: data.mensaje }
      } else {
        //
        //Si existe la oferta actual, significa que ha habido un cambio parcial
        //
        texto = { status: 'Parcial', mensaje: intl.formatMessage({ id: "The offer has been partially converted to an order because it had products out of stock"}) }
      }
    } else {
      //
      //Si ha ocurrido algún problema lo tratamos y los devulvemos
      //
      if (data.mensaje.message) {
        texto = { status: 'KO', mensaje: `${intl.formatMessage({ id: "A problem has occurred, contact the administrator"})}. ${data.mensaje.message}` }
        const mensaje = data.mensaje.message
        if (mensaje.includes('There are not inventory to create order.') || mensaje.includes('No hay stock suficiente para crear el pedido.')) {
          texto = { status: 'KO', mensaje: intl.formatMessage({ id: "Order out of stock"}) }
        } else if (mensaje.includes('This customer allows you to split the quantities of the quotation when converting it to order.') || mensaje.includes('Este cliente permite dividir las cantidades de la oferta al convertirla a pedido.')) {
          texto = { status: 'KO', mensaje: intl.formatMessage({ id: "The customer does not allow partial deliveries, there is not enough stock for the entire order."}) }
        } else if (mensaje.includes('contains lines with a sale price below cost.') || mensaje.includes('contiene líneas con precio venta inferior al coste.')) {
          texto = { status: 'KO', mensaje: intl.formatMessage({ id: "The offer contains lines with a selling price below cost."}) }
        }
      }
    }
    //
    //Devolvemos el resultado
    //
    return texto
  }).catch((err) => {
    console.log(err.message)
  })
}

// ** Convertir oferta a pedido
export const convertSQToOrder = async (documentNo, codigoCliente, intl, company) => {
  try {
    //
    //Muestro por pantalla el mensaje de que se ha iniciado el proceso
    //
    displayInfoMsg(intl.formatMessage({ id: "Process initiated"}))
    let objNew = {}
    //
    //Si No es multiempresa:
    //
    if (company !== 43) {
      objNew = { documentNo };
    } else {
      //
      //Si es multiempresa, se busca a que empresa pertenece la oferta
      //      
      const response = await apiNavisionNew.navisionControllerGetEmpresaPorIdDato(documentNo, 'documentNo', 'salesQuoteHeader', codigoCliente);
     objNew = { documentNo, companyId: response.data.companyId };      
    }
    //
    //Se devuelven los resultados 
    //
    return await convierteOfertaAPedido(objNew, intl, documentNo);
  } catch (err) {
    console.error(err.message);
    return displayErrorMsg(err.message);
  }  
}

export const switchBilltoSellto = () => {
  return async (dispatch) => {
    dispatch({
      type: SWITCH_BILLTO_SELLTO
    })
  }
}

export async function stockProductos (documentNo, tarifa, companyId, lineas) {
  if (companyId !== 43) {
      const listaSlugs = lineas
      .filter(item => item.no !== "PORTES") // Filtra los elementos que NO sean "PORTES"
      .map(item => item.no); // Extrae los `no` restantes
      const arraySlugs = listaSlugs.join("|")
      const encodedSlugs = encodeURIComponent(arraySlugs); // Codifica los slugs para la URL
      const {data: productoNav } = await axios.get(`${devuelveBasePath()}/query-page-products/${documentNo}/${encodedSlugs}/?customerPriceGroup=${tarifa}`)
      const productoParsed = JSON.parse(productoNav.result?.return_value ? productoNav.result.return_value : 0)
      const lineasConStock = lineas.map(item => {
        // Busca el producto en la API por algún identificador común (por ejemplo, SKU o ID)
        const productoEncontrado = productoParsed.Items.find(p => p['Model'] === item.no); 
      
        // Determina el icono según la cantidad en stock
        let iconoStock;
        if (!productoEncontrado || Number(productoEncontrado['InventoryAvailable']) < item.quantity) {
          iconoStock = <X size={25} className="mx-1" style={{ color: "red" }} />;
        } else {
          iconoStock = <Check size={25} className="mx-1" style={{ color: "green" }} />;
        }
      
        // Retorna el nuevo objeto con el stock asignado
        return { ...item, stock: iconoStock };
      });
      return lineasConStock;
  } else {
    let companies = [];
    let listaSlugs = [];
    const results = [];
    for (const item of lineas) {
      if (item.no !== "PORTES") {
        const { data: productosPim } = await instance().get(`/B2bProductos/${item.no}`);
    
        try {
          const allCompaniesData = await fetchCompaniesForProducts(
            productosPim, 
            localStorage.getItem('clienteDefecto').split(' ')[0]
          );
    
          companies = Object.keys(allCompaniesData);
    
          for (const element of companies) {
            listaSlugs = allCompaniesData[element].map(item => item.slug);
            results.push({
              [element]: listaSlugs
            });
          }
        } catch (error) {
          console.error('Error en la llamada a fetchCompaniesForProducts:', error);
        }
      }
    }
    /*const promises = results.map(async (result) => {
      const company = Object.keys(result)[0];
      const slugs = result[company];
      const { data: productoNav } = await axios.get(`${devuelveBasePath()}/query-page-products-empresa/${documentNo}/${slugs[0]}/${company}/?customerPriceGroup=${tarifa}`)
      const productoParsed = JSON.parse(productoNav.result?.return_value ? productoNav.result.return_value : 0)
      return productoParsed;
    });*/
    // Agrupa los slugs por compañía
    const groupedByCompany = {};

    results.forEach(result => {
      const company = Object.keys(result)[0];
      const slugs = result[company];

      if (!groupedByCompany[company]) {
        groupedByCompany[company] = [];
      }

      groupedByCompany[company].push(...slugs);
    });

    // Una petición por compañía, con todos los slugs concatenados
    const promises = Object.entries(groupedByCompany).map(async ([company, slugs]) => {
      const arraySlugs = slugs.join("|");
      const encodedSlugs = encodeURIComponent(arraySlugs);

      try {
        const { data: productoNav } = await axios.get(`${devuelveBasePath()}/query-page-products-empresa/${documentNo}/${encodedSlugs}/${company}/?customerPriceGroup=${tarifa}`);
        const productoParsed = JSON.parse(productoNav.result?.return_value ? productoNav.result.return_value : 0);
        return productoParsed;
      } catch (error) {
        console.error(`Error obteniendo productos para la compañía ${company}`, error);
        return { Items: [] };
      }
    });
    const productosParsed = await Promise.all(promises);
    const productosAplanados = productosParsed.flatMap(producto => producto.Items);
    const lineasConStock = lineas.map(item => {
      const productoEncontrado = productosAplanados.find(p => p['Model'] === item.no);
      let iconoStock;
      if (!productoEncontrado || Number(productoEncontrado['InventoryAvailable']) < item.quantity) {
        iconoStock = <X size={25} className="mx-1" style={{ color: "red" }} />;
      } else {
        iconoStock = <Check size={25} className="mx-1" style={{ color: "green" }} />;
      }
      return { ...item, stock: iconoStock };
    }
    );
    return lineasConStock;
  }
  
}

export async function stockRepuestos (documentNo, producto, tarifa, cantidad) {
  if (producto !== 'PORTES') {
    const jsonParaObtenerStock = {
      //pCustomer,
      pCustomer: documentNo,
      pcustomerPriceGroup: '',
      pItem: producto,
      pRepuestos: true
    }  

    const objJSON = JSON.stringify(jsonParaObtenerStock) // <-- creamos el JSON a enviar
    const dataStock  = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_QueryExternalStock", objJSON)

    if (dataStock?.data?.mensaje?.message) {
      return displayErrorMsg(dataStock?.data?.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
    }

    if (dataStock.data.status === "OK") {
        const productoParsed = JSON.parse(dataStock.data.mensaje);
        let cantidadStock
        if (productoParsed === 0) {
          cantidadStock = 0
        } else {
          cantidadStock = productoParsed.Items[0]['InventoryAvailable']
        }
        if (cantidadStock < cantidad) {
          return <X size={25} className='mx-1' style={{ color: "red" }}/>;
        } else {
          return <Check size={25} className='mx-1' style={{ color: "green" }}/>;
        }
    } else {
        const resultJson = JSON.stringify({ status: "EMPTY", mensaje: 'NO STOCK'});
        console.log('ERROR: Consultando el stock del producto sustitutivo: ', dataStock)
        return JSON.parse(resultJson);
    }
  }
}

// ** Get Query Customer
export const getDireccionesCliente = (cliente, shop = true) => {
  return async (dispatch) => {
    try {
      const cod = getUserData()
      let filter = {where: {
          ['customerNo']:`${cliente.split(' ')[0]}`,
          ['shop']: shop
        }
      }
      if (cod.companyId !== 43) {
        filter = {where: {
          ['customerNo']:`${cliente.split(' ')[0]}`,
          ['shop']: shop,
          ['companyId'] : cod.companyId
        }
      }
      }
      const data = await clienteasApi.clientesControllerFind(JSON.stringify(filter));
      return data;
    } catch (err) {
      console.error(err.message)
    }
  }
}